import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const style = {
  name: {
    overflow: 'hidden',
    textAlign: 'left',
    position: 'relative',
    whiteSpace: 'break-spaces',
    overflowWrap: 'break-word',
  },
  tagsHeader: {
    width: 195,
    overflow: 'hidden',
    textAlign: 'left',
    paddingLeft: 8,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    position: 'relative',
  },
  tagsBody: {
    width: 195,
    overflow: 'hidden',
    paddingLeft: 8,
    textAlign: 'left',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    position: 'relative',
    fontSize: 8,
  },
  tagWrapper: {
    overflow: 'hidden',
    whiteSpace: 'break-spaces',
    overflowWrap: 'break-word',
  },
};

export const BodyTr = styled.tr`
  border-top: 1px solid ${ColorSF2.mediumGray};
  text-decoration: none;
  cursor: pointer;
  height: 54px;
  background-color: ${ColorSF2.white};

  &:hover {
    background-color: ${ColorSF2.skyBlue};
  }

  &:first-child {
    border-top: none;
  }

  &.timelineSelected {
    background-color: ${ColorSF2.skyBlue};
  }
`;
export const HeaderTr = styled(BodyTr)`
  height: 27px;
  font-size: 12px;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  background-color: ${ColorSF2.paleBlue};

  &:hover {
    background-color: ${ColorSF2.paleBlue};
  }

  &:first-child {
    border-top: ${props =>
      props.fullscreen ? 'none' : `1px solid ${ColorSF2.mediumGray}`};
  }

  &.timelineSelected {
    background-color: ${ColorSF2.paleBlue};
  }
`;
export const CheckArea = styled.div`
  padding-left: 10px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;
export const CheckboxWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const DefaultCheckbox = styled.input`
  display: none;
`;
export const CheckboxLabel = styled.label`
  width: 20px;
  height: 20px;
`;
export const ThColumn = styled.th`
  height: 27px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0px;
`;
export const TdColumn = styled.td`
  height: 54px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0px;
  @media (max-width: 830px), (max-height: 530px) {
    height: 36px;
    font-size: 12px;
  }
`;
export const ThColumnCheckbox = styled(ThColumn)`
  width: 35px;
  @media (max-width: 830px), (max-height: 530px) {
    width: 24px;
  }
`;
export const TdColumnCheckbox = styled(TdColumn)`
  width: 35px;
  @media (max-width: 830px), (max-height: 530px) {
    width: 24px;
  }
`;
export const ThColumnMedia = styled(ThColumn)`
  width: 65px;
  text-align: center;
`;
export const MediaIcon = styled.img`
  height: 35px;
  cursor: pointer;
`;
export const TdColumnMedia = styled(TdColumn)`
  width: 65px;
  text-align: center;
  position: relative;
  align-items: center;
`;
export const MediaContainer = styled.div`
  display: flex;
  justify-content: center;
`;
export const ThColumnPosition = styled.th`
  width: 50px;
  overflow: hidden;
  padding-left: 0px;
  text-align: center;
  white-space: nowrap;
`;
export const TdColumnPosition = styled.td`
  width: 50px;
  overflow: hidden;
  padding-left: 0px;
  text-align: center;
  white-space: nowrap;
  @media (max-width: 830px), (max-height: 530px) {
    font-size: 12px;
  }
`;
export const ThColumnText = styled(ThColumn)`
  width: 200px;
  padding-left: ${props => `${props.padding || 8}px`};
  text-align: left;
`;
export const TdColumnText = styled(TdColumn)`
  width: 200px;
  padding-left: ${props => `${props.padding || 8}px`};
  text-align: left;
`;
export const ThColumnDate = styled.th`
  width: ${props => (props.fullscreen ? '175px' : '110px')};
  text-align: center;
  @media (max-width: 830px), (max-height: 530px) {
    width: ${props => (props.fullscreen ? '90px' : '110px')};
  }
`;
export const TdColumnDate = styled.td`
  width: ${props => (props.fullscreen ? '175px' : '110px')};
  text-align: center;
  padding-left: 5px;
  @media (max-width: 830px), (max-height: 530px) {
    font-size: 12px;
    width: ${props => (props.fullscreen ? '90px' : '110px')};
  }
`;
export const SortColumn = styled.div`
  cursor: pointer;
  display: flex;
  columns: row;
  justify-content: ${props => (props.center ? 'center' : 'left')};
  align-items: center;
  margin-left: ${props => (props.marginLeft ? '10px' : '0px')};
`;
export const EllipsisText = styled.div`
  overflow: hidden;
  white-space: break-spaces;
  overflow-wrap: break-word;
`;
export const PlayCircleStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '15px',
  height: '15px',
  zIndex: '900',
};

export const Lists = styled.div`
  height: 100%;
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
export const HeaderTableWrapper = styled.div`
  height: 28px;
`;
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
  table-layout: fixed;
  height: 100%;
`;
export const Thead = styled.thead`
  background-color: ${ColorSF2.paleBlue};
`;
export const TableWrapper = styled.div`
  height: calc(100% - 28px);
  overflow-x: hidden;
  overflow-y: auto;
`;
export const Tbody = styled.tbody`
  background-color: ${ColorSF2.offWhite};
  flex-direction: column;
`;
